export const fmtBRL = (v) =>
  'R$ ' + Number(v).toFixed(2).replace('.', ',');

// Regras de geração de itens a partir dos campos de entrada
export function getGenerated({ hospedes, banheiros, quartos, beds }) {
  return {
    fronha:       hospedes,
    toalha_banho: hospedes,
    toalha_rosto: banheiros,
    piso:         banheiros,
    piscina:      quartos,
    manta:        quartos,
    solteiro:     beds.solteiro  * 2,
    queen:        beds.queen     * 2,
    king:         beds.king      * 2,
    superking:    beds.superking * 2,
  };
}

export const ITEM_LABELS = {
  fronha:       'Fronha',
  toalha_banho: 'Toalha de Banho',
  toalha_rosto: 'Toalha de Rosto',
  piso:         'Piso de Banheiro',
  piscina:      'Toalha de Piscina',
  manta:        'Manta',
  solteiro:     'Lençol Solteiro',
  queen:        'Lençol Queen',
  king:         'Lençol King',
  superking:    'Lençol Superking',
};
